export const notEmptyValidation = (value) => value && value.replace(/\s/g, "").length > 0;
export const hushedValueValidation = (value) => {
  if (typeof value === "string") return notEmptyValidation(value);
  if (value.is_set || value.keep_value) return true;
  return notEmptyValidation(value.set_value);
};
